/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function LinksToOtherWebsitesCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Links to Other Websites</Title>
      <Divider my="md" />
      <Text>
        Our Service may contain links to other websites that are not operated by
        Us. If You click on a third party link, You will be directed to that
        third party&apos;s site. We strongly advise You to review the Privacy
        Policy of every site You visit.
      </Text>

      <Text mt="sm">
        We have no control over and assume no responsibility for the content,
        Privacy Policies or practices of any third party sites or services.
      </Text>
    </Card>
  );
}
